const actions = {
  IDENTIFY_LEAD_REQUEST: 'IDENTIFY_LEAD_REQUEST',
  IDENTIFY_LEAD_FAILURE: 'IDENTIFY_LEAD_FAILURE',
  IDENTIFY_LEAD_SUCCESS: 'IDENTIFY_LEAD_SUCCESS',
}

export default actions
